export const DATASET_STREAM_MAX_RETRIES = 3;

export class CustomError<T = unknown> extends Error {
  code: number;
  message: string;
  details?: T;
  reason?: string;

  constructor(message: string, code: number, details?: T, reason?: string) {
    super(message);
    this.code = code;
    this.message = message;
    this.details = details;
    this.reason = reason;
  }
}

export class UnauthorizedStreamError extends Error {
  constructor() {
    super("Unauthorized");
    this.name = "UnauthorizedStreamError";
  }
}
